import { Bias } from '@/diagrams/models/bias'

export default [
  { value: Bias.Negativ, text: "negativ" },
  { value: Bias.Neutral, text: "neutral" },
  { value: Bias.Positiv, text: "positiv" },
]
